import { render, staticRenderFns } from "./PurchaseOrderTrendChart.vue?vue&type=template&id=3b045b6c"
import script from "./PurchaseOrderTrendChart.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports